<div class="c-modal-material c-modal-overlay c-modal--img-only is-active"></div>
<div id="modal-DeviceNumberDeviceReveal" class="c-modal c-modal--img-only is-active"
  style="min-width: 280px; max-width: 600px;">
  <button class="c-modal__close" (click)="close()"></button>
  <div class="c-modal__body"><img src="/assets/images/device/DnDevice.png" alt="Device number"></div>
</div>
